import store from "./store"
export default function translation(text, key='name', children='children')
{
    // if(text&&typeof text == 'string'&&!text.includes('\r\n')){
    //     text = text.replace(/\n/g,'\r\n')
    // } 
    if(Array.isArray(text))
    {
        for(let i = 0; i<text.length; i++)
        {
            if(typeof text[i]==='string')
                text[i] = store.getters.translations[text[i]]||text[i]
            else if(typeof text[i]==='object')
            {
                text[i][key] = store.getters.translations[text[i][key]]||text[i][key]

                translation(text[i][children], key, children)
            }
        }

    }
    if(text)
        if(typeof text==='string')
            return store.getters.translations[text.replace(/\n/g,'').replace(/\r/g,'')]||text
        return store.getters.translations[text]||text 
}

export function websiteText()
{
    return store.getters.website_text
}

